export const state = {
  loginUserId: '',
  exportFlag: '',
  rates: [],
  posts: [
    {
      postId: '',
      postName: '',
      users: [
        {
          userName: ''
        }
      ]
    }
  ],
  users: [
    {
      userId: '',
      userName: ''
    }
  ]
}
export const mutations = {
  reversedPostsCheck (state, payload) {
    for (var i = 0; i < state.posts.length; i++) {
      if (state.posts[i].postId === payload.postId) {
        state.posts[i].checked = !(state.posts[i].checked)
        break
      }
    }
  },
  reversedUsersCheck (state, payload) {
    for (var i = 0; i < state.users.length; i++) {
      if (state.users[i].userId === payload.userId) {
        state.users[i].checked = !(state.users[i].checked)
        break
      }
    }
  },
  setRatesInfos (state, response) {
    for (var i in response.data['data']) {
      if (response.data['data'][i] === null) {
        response.data['data'][i] = ''
      }
    }
    for (var j = 0; j < response.data['data'].length; j++) {
      response.data['data'][j]['checked'] = false
    }
    state.rates = response.data['data']
  },
  setUserInfos (state, response) {
    if (response.data['data'] === null) {
      response.data['data'] = []
    }
    for (var i = 0; i < response.data['data'].length; i++) {
      response.data['data'][i]['checked'] = false
    }
    state.users = response.data['data']
  },
  setPostInfos (state, response) {
    if (response.data['data'] === null) {
      response.data['data'] = []
    }
    for (var i = 0; i < response.data['data'].length; i++) {
      response.data['data'][i]['checked'] = false
    }
    state.posts = response.data['data']
  },
  setLoginUserId (state, payload) {
    state.loginUserId = payload
  }
}
export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/assessmentInfoModules/assessmentInfoMutation.js